module.exports = __webpack_public_path__ + "static/media/logo_b.f07927f6.png";